import { Box, Text } from 'ink';
import Link from 'ink-link';
import { Build } from '@todesktop/shared';
import { useEffect } from 'react';
import logForCI from '../utilities/logForCI';
import useExit from '../utilities/useExit';
import fixMacUrl from '../utilities/fixMacUrl';

export default function BuildCompleteMessage({ build }: { build: Build }) {
  const exit = useExit();
  let url = build.standardUniversalDownloadUrl;

  if (process.platform === 'darwin' && build.mac?.standardDownloadUrl) {
    // Otherwise the download link may link to a Intel file when on Apple Silicon
    url = fixMacUrl(build.mac.standardDownloadUrl);
  }

  logForCI(`Build complete! ${url}`);

  // On build completion, exit with non-error code
  useEffect(() => {
    if (url) {
      // Just to avoid updating state after exiting the React app
      setTimeout(exit, 10);
    }
  }, [exit, url]);

  return (
    <Box marginBottom={1}>
      <Text>
        <Text bold>Build complete!</Text>{' '}
        <Link fallback={false} url={url}>
          {url || ''}
        </Link>
      </Text>
    </Box>
  );
}
